export function showOverlay()
{
    document.getElementById('overlay').classList.add('active');
}

export function hideOverlay()
{
    document.getElementById('overlay').classList.remove('active');
}
